import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// MUI Icons
import InfoIcon from '@mui/icons-material/Info';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { SxProps } from '@mui/material';
import { Theme } from '@emotion/react';

type InfoBoxProps = {
  labelToken: string;
  sx?: SxProps<Theme>;
  color?: 'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  icon?: 'info' | 'warning' | 'error';
};

const InfoBox: FC<InfoBoxProps> = (props) => {
  const { labelToken, sx, color = 'primary', icon = 'info' } = props;
  const { t } = useTranslation();

  const IconComponent = icon === 'error' ? ErrorOutlineIcon : icon === 'warning' ? WarningAmberIcon : InfoIcon;

  return (
    <Box display="flex" alignItems="center" gap={1} sx={sx}>
      <IconComponent sx={{ fontSize: 32 }} color={color} />
      <Typography variant="body1">{t(labelToken)}</Typography>
    </Box>
  );
};

export default InfoBox;
